import React from "react";
import { Outlet } from "react-router-dom";
import { makeStyles } from "@material-ui/core";

import TopBar from "./TopBar";
import SnackBar from "../../layouts/SnackBar";
import RentalManageLogout from "src/components/RentalManageLogout/RentalManageLogout";
import RentalErrorMessageDialog from "src/components/RentalErrorMessageDialog/RentalErrorMessageDialog";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 60,
    [theme.breakpoints.up("sm")]: { paddingTop: 69 },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    overflow: "auto",
  },
}));

const CheckinLayout = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <TopBar />
      <RentalManageLogout />
      <RentalErrorMessageDialog />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <SnackBar />
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckinLayout;
